export default {
  addEventListener() {},
  async fetch() {
    return {
      // Mock the state, for the web
      isInternetReachable: true,
    };
  },
};
